

  
const content = `# OnData Encryption
OnData provides innovative approaches to secure and protect sensitive data in your databases while preserving the data formats. The algorithms OnData uses for encryption 
are based on AES-256 encryption mechanism and are approved by the National Institute of Standards and Technology (NIST). 

Based on data classification, the sensitive data, confidential data and regulated data can be automatically encrypted for enhanced security. Such data will stay encrypted at rest, 
in transit and even at runtime. It will only be decrypted for a user when such user has been explicitly granted necessary permissions to access the data. An organization can 
not only configure but also enforce the data access policies on all data across the organization.

## Best Practices
The OnData Encryption feature is intended to protect sensitive, confidential and regulated data. To achieve that purpose without comprising the structure or integrity of the 
databases, please follow the OnData Encryption best practices listed below.

- Perform data classification on data fields before applying data encryption rules. If a data field is not classified as sensitive, confidential or regulated, no encryption rule 
should be applied to that data field. The encryption and decryption process does introduce some overhead to the data exchange with the database. We should avoid such overhead 
if there is no real business need to protect a data field that is not sensitive, confidential or regulated;

- Do not encrypt any identity columns. The values of an identity column are automatically generated by the database engine. Such columns are typically used as primary keys and 
foreign keys in tables. There is no need to protect such data fields, and encryption may cause issues to the relationships among the entities.

- The OnData encryption feature does come with certain limitations. Please review such limitations before applying the encryption rules.`
  
export default content;
